// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import your translation files
import translationEN from "./locales/en/translation.json";
import translationJA from "./locales/ja/translation.json";

// Check if a language is saved in localStorage
const savedLanguage = localStorage.getItem("selectedLanguage");

i18n
  .use(LanguageDetector) // Use the language detector
  .use(initReactI18next) // Passes i18n down to react-i18next
  .init({
    resources: {
      en: {
        translation: translationEN,
      },
      ja: {
        translation: translationJA,
      },
    },
    lng: savedLanguage || "ja", // Use saved language or default to Japanese
    fallbackLng: "en", // Fallback language
    interpolation: {
      escapeValue: false, // React does escaping by default
    },
    detection: {
      order: ["localStorage", "cookie", "navigator"], // Order of language detection
      lookupLocalStorage: "selectedLanguage", // Key to look for in localStorage
      caches: ["localStorage"], // Cache the language in localStorage
    },
  });

export default i18n;
